module.exports = __webpack_public_path__ + "img/thumb_shops_shop_front.6489b3f0.jpg";